import { requestConst } from '../consts';

export function requests(state = {}, action) {
    switch (action.type) {
        case requestConst.REQUESTS_START_REQUEST:
            return { ...state, getting: true, hasErrors: false };
        case requestConst.REQUESTS_END_REQUEST:
            return { ...state, getting: false };
        case requestConst.REQUESTS_SUCCESS:
            return {
                ...state,
                requests: action.requests,
            };
        case requestConst.REQUESTS_FAILURE:
            return {
                ...state,
                getting: false,
                errors: action.errors,
                hasErrors: true,
            };
        case requestConst.CLEAR_ERRORS:
            return {
                ...state,
                errors: undefined,
                hasErrors: false,
            };
        case requestConst.CLEAR:
            return {};
        case requestConst.REQUESTS_SET_EVENT:
            return {
                ...state,
                eventName: action.eventName,
            };
        default:
            return state;
    }
}
